/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `from_column` - From column
* `from_import` - From Import
 */
export type TimePeriodSourceEnum = typeof TimePeriodSourceEnum[keyof typeof TimePeriodSourceEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimePeriodSourceEnum = {
  from_column: 'from_column',
  from_import: 'from_import',
} as const;
